'use strict';

import Vue from 'vue';
import Vuex from 'vuex';
import dateTimePicker from './modules/dateTimePicker';
import confirmation from './modules/confirmation';
import settings from './modules/settings';
import translation from './modules/translation';
import signin from './modules/signin';
import signup from './modules/signup';
import forgotPassword from './modules/forgotPassword';
import dashboard from './modules/dashboard';
import configuration from './modules/configuration';
import list from './modules/list';
import listItem from './modules/listItem';
import form from './modules/form';
import table from './modules/table';
import catalog from './modules/catalog';

Vue.use(Vuex);


export default new Vuex.Store({
    modules: {
        dateTimePicker,
        confirmation,
        settings,
        translation,
        signin,
        signup,
        forgotPassword,
        dashboard,
        configuration,
        list,
        listItem,
        form,
        table,
        catalog
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js